import { combineReducers } from 'redux'
import * as actionTypes from './actionTypes'

export const renderReducer = (state = {}, action) => {
	switch (action.type) {
		case actionTypes.RENDER_SPREAD_REQUEST:
		case actionTypes.RENDER_SPREAD_ERROR:
			return {
				...state,
				[action.renderKey]: null,
			}

		case actionTypes.RENDER_SPREAD_SUCCESS:
			return {
				...state,
				[action.renderKey]: action.render,
			}

		default:
			return state
	}
}

export const errorReducer = (state = {}, action) => {
	switch (action.type) {
		case actionTypes.RENDER_SPREAD_REQUEST:
		case actionTypes.RENDER_SPREAD_SUCCESS:
			return {
				...state,
				[action.renderKey]: null,
			}

		case actionTypes.RENDER_SPREAD_ERROR:
			console.error(action.error)
			return {
				...state,
				[action.renderKey]: action.error,
			}

		default:
			return state
	}
}

export const fetchingReducer = (state = {}, action) => {
	switch (action.type) {
		case actionTypes.RENDER_SPREAD_REQUEST:
			return {
				...state,
				[action.renderKey]: true,
			}

		case actionTypes.RENDER_SPREAD_SUCCESS:
		case actionTypes.RENDER_SPREAD_ERROR:
			return {
				...state,
				[action.renderKey]: false,
			}

		default:
			return state
	}
}

export default combineReducers({
	render: renderReducer,
	error: errorReducer,
	fetching: fetchingReducer,
})

export const getRenderByKey = (state, renderKey) => state.render[renderKey]
export const getErrorByKey = (state, renderKey) => state.error[renderKey]
export const getFetchingByKey = (state, renderKey) => (state.fetching[renderKey] ? true : false)
